import script from "./InfoForCandidate.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoForCandidate.vue?vue&type=script&setup=true&lang=js"

import "./InfoForCandidate.vue?vue&type=style&index=0&id=09784a8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09784a8d"]])

export default __exports__